import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Drawer, List, ListItem, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from '@material-ui/icons/Search';
import MenuItemMovil from './MenuItemMovil';

const useStyles = makeStyles(() => ({
    closeMenuButton: {
        marginRight: 'auto',
        marginLeft: 0,
        backgroundColor: "transparent",
        border: "none !important",
        boxShadow: "none",
        color: "#116F5C",
    }
}));

const MenuOnDrawer = (props) => {
    const classes = useStyles();
    const { data, drawerOpen, toggleDrawer } = props;
    const sideList = side => (
        <List component="nav" disablePadding className="menuMovil" > 
            {
                data.items.map((item, index) => (
                    <MenuItemMovil toggleDrawer={toggleDrawer} {...item} key={`nav-${index}`} />
                ))
            }
            <ListItem button>
                <a href="#" style={{color:"white", padding: "5px 0px", textDecoration: "none"}} >Ecoconsulta</a>
            </ListItem>
            <ListItem button id='openModalBuscadorGeneral' component="a" onClick={toggleDrawer}>
                <SearchIcon style={{fontSize:"30px", color:"white", width: "100%", paddingRight: "85%"}} />
            </ListItem>
        </List>
    );

    return (
        <Drawer open={drawerOpen} onClose={toggleDrawer} className="menuM" >
            <IconButton
                aria-label="close drawer"
                onClick={toggleDrawer}
                className={`closeMenuMovilIcon ${classes.closeMenuButton}`}
                size="medium"
            >
                <CloseIcon />
            </IconButton>
            {sideList("left")}
        </Drawer>
    );
}

export default MenuOnDrawer;